import React, { useState } from 'react';


import {
  View,
} from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphLatestProjects = ({ id }) => {
  const [currentPage, setCurrentPage] = useState(0);

  return (
    <div id={id} className="ParagraphLatestProjects">

      {/* Start Content */}
      <View
        className="ParagraphLatestProjects__view"
        page={currentPage}
        args={['all']}
        id="latest_projects"
        setCurrentPage={setCurrentPage}
        display="block_1"
      />
      {/* End Content */}

    </div>
  );
};

export default ParagraphLatestProjects;
